import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown, faCaretRight } from '@fortawesome/sharp-light-svg-icons';
import faTv from './fortawesomeIcons/free-solid-svg-icons/faTv';
import faMobileScreenButton from './fortawesomeIcons/free-solid-svg-icons/faMobileScreenButton';
import faFont from './fortawesomeIcons/free-solid-svg-icons/faFont';
import faCircleMinusSolid from './fortawesomeIcons/free-solid-svg-icons/faCircleMinus';
import faExternalLinkAlt from './fortawesomeIcons/free-solid-svg-icons/faExternalLinkAlt';
import faChevronDown from './fortawesomeIcons/free-solid-svg-icons/faChevronDown';
import faCamera from './fortawesomeIcons/free-solid-svg-icons/faCamera';
import faFlag from './fortawesomeIcons/free-solid-svg-icons/faFlag';
import faPencil from './fortawesomeIcons/free-solid-svg-icons/faPencil';
import faPenToSquareSolid from './fortawesomeIcons/free-solid-svg-icons/faPenToSquare';
import faFileImport from './fortawesomeIcons/free-solid-svg-icons/faFileImport';
import faPaperclip from './fortawesomeIcons/free-solid-svg-icons/faPaperclip';
import faFile from './fortawesomeIcons/free-solid-svg-icons/faFile';
import faComment from './fortawesomeIcons/free-solid-svg-icons/faComment';
import faComments from './fortawesomeIcons/free-solid-svg-icons/faComments';
import faDownload from './fortawesomeIcons/free-solid-svg-icons/faDownload';
import faRotate from './fortawesomeIcons/free-solid-svg-icons/faRotate';
import faCloud from './fortawesomeIcons/free-solid-svg-icons/faCloud';
import faFilter from './fortawesomeIcons/free-solid-svg-icons/faFilter';
import faShare from './fortawesomeIcons/free-solid-svg-icons/faShare';
import faPaperPlane from './fortawesomeIcons/free-solid-svg-icons/faPaperPlane';
import faFolder from './fortawesomeIcons/free-solid-svg-icons/faFolder';
import faFolderOpen from './fortawesomeIcons/free-solid-svg-icons/faFolderOpen';
import faMagnet from './fortawesomeIcons/free-solid-svg-icons/faMagnet';
import faEllipsisVertical from './fortawesomeIcons/free-solid-svg-icons/faEllipsisVertical';
import faArrowsMaximize from './fortawesomeIcons/pro-light-svg-icons/faArrowsMaximize';
import faCalendar from './fortawesomeIcons/pro-light-svg-icons/faCalendar';
import faCalendarClock from './fortawesomeIcons/pro-light-svg-icons/faCalendarClock';
import faChartLine from './fortawesomeIcons/pro-light-svg-icons/faChartLine';
import faCircleCheck from './fortawesomeIcons/pro-light-svg-icons/faCircleCheck';
import faClock from './fortawesomeIcons/pro-light-svg-icons/faClock';
import faDiagramSubtask from './fortawesomeIcons/pro-light-svg-icons/faDiagramSubtask';
import faFontCase from './fortawesomeIcons/pro-light-svg-icons/faFontCase';
import faHashtag from './fortawesomeIcons/pro-light-svg-icons/faHashtag';
import faHeading from './fortawesomeIcons/pro-light-svg-icons/faHeading';
import faImage from './fortawesomeIcons/pro-light-svg-icons/faImage';
import faInputPipe from './fortawesomeIcons/pro-light-svg-icons/faInputPipe';
import faList from './fortawesomeIcons/pro-light-svg-icons/faList';
import faListCheck from './fortawesomeIcons/pro-light-svg-icons/faListCheck';
import faListDropdown from './fortawesomeIcons/pro-light-svg-icons/faListDropdown';
import faListRadio from './fortawesomeIcons/pro-light-svg-icons/faListRadio';
import faPaintbrushPencil from './fortawesomeIcons/pro-light-svg-icons/faPaintbrushPencil';
import faSignature from './fortawesomeIcons/pro-light-svg-icons/faSignature';
import faSquarePollHorizontal from './fortawesomeIcons/pro-light-svg-icons/faSquarePollHorizontal';
import faTableCells from './fortawesomeIcons/pro-light-svg-icons/faTableCells';
import faTableColumns from './fortawesomeIcons/pro-light-svg-icons/faTableColumns';
import faTableRows from './fortawesomeIcons/pro-light-svg-icons/faTableRows';
import faFolderArrowUp from './fortawesomeIcons/pro-light-svg-icons/faFolderArrowUp';
import faMoneyCheckDollarPen from './fortawesomeIcons/pro-light-svg-icons/faMoneyCheckDollarPen';

import faArrows from './fortawesomeIcons/pro-regular-svg-icons/faArrows';
import faArrowsLeftRight from './fortawesomeIcons/pro-regular-svg-icons/faArrowsLeftRight';
import faArrowsUpDown from './fortawesomeIcons/pro-regular-svg-icons/faArrowsUpDown';
import faBarcode from './fortawesomeIcons/pro-regular-svg-icons/faBarcode';
import faCheck from './fortawesomeIcons/pro-regular-svg-icons/faCheck';
import faCheckDouble from './fortawesomeIcons/pro-regular-svg-icons/faCheckDouble';
import faCheckSquare from './fortawesomeIcons/pro-regular-svg-icons/faCheckSquare';
import faChevronCircleLeft from './fortawesomeIcons/pro-regular-svg-icons/faChevronCircleLeft';
import faChevronCircleRight from './fortawesomeIcons/pro-regular-svg-icons/faChevronCircleRight';
import faCircle from './fortawesomeIcons/pro-regular-svg-icons/faCircle';
import faCircleMinus from './fortawesomeIcons/pro-regular-svg-icons/faCircleMinus';
import faCircleInfo from './fortawesomeIcons/pro-regular-svg-icons/faCircleInfo';
import faColumns3 from './fortawesomeIcons/pro-regular-svg-icons/faColumns3';
import faCopy from './fortawesomeIcons/pro-regular-svg-icons/faCopy';
import faDotCircle from './fortawesomeIcons/pro-regular-svg-icons/faDotCircle';
import faEdit from './fortawesomeIcons/pro-regular-svg-icons/faEdit';
import faFileLines from './fortawesomeIcons/pro-regular-svg-icons/faFileLines';
import faGripVertical from './fortawesomeIcons/pro-regular-svg-icons/faGripVertical';
import faImages from './fortawesomeIcons/pro-regular-svg-icons/faImages';
import faLink from './fortawesomeIcons/pro-regular-svg-icons/faLink';
import faMoneyCheckPen from './fortawesomeIcons/pro-regular-svg-icons/faMoneyCheckPen';
import faPlus from './fortawesomeIcons/pro-regular-svg-icons/faPlus';
import faSquare from './fortawesomeIcons/pro-regular-svg-icons/faSquare';
import faTimes from './fortawesomeIcons/pro-regular-svg-icons/faTimes';
import faCloudArrowUp from './fortawesomeIcons/pro-regular-svg-icons/faCloudArrowUp';
import faUpload from './fortawesomeIcons/pro-regular-svg-icons/faUpload';
import faMagnifyingGlass from './fortawesomeIcons/pro-regular-svg-icons/faMagnifyingGlass';
import faBan from './fortawesomeIcons/pro-regular-svg-icons/faBan';
import faTableTree from './fortawesomeIcons/pro-regular-svg-icons/faTableTree';

import faCircleXmark from './fortawesomeIcons/sharp-light-svg-icons/faCircleXmark';

import faAlignCenter from './fortawesomeIcons/sharp-regular-svg-icons/faAlignCenter';
import faAlignLeft from './fortawesomeIcons/sharp-regular-svg-icons/faAlignLeft';
import faAlignRight from './fortawesomeIcons/sharp-regular-svg-icons/faAlignRight';
import faArrowTurnDownLeft from './fortawesomeIcons/sharp-regular-svg-icons/faArrowTurnDownLeft';
import faAsterisk from './fortawesomeIcons/sharp-regular-svg-icons/faAsterisk';
import faBold from './fortawesomeIcons/sharp-regular-svg-icons/faBold';
import faCodeBranch from './fortawesomeIcons/sharp-regular-svg-icons/faCodeBranch';
import faCog from './fortawesomeIcons/sharp-regular-svg-icons/faCog';
import faDatabase from './fortawesomeIcons/sharp-regular-svg-icons/faDatabase';
import faEllipsis from './fortawesomeIcons/sharp-regular-svg-icons/faEllipsis';
import faEllipsisStroke from './fortawesomeIcons/sharp-regular-svg-icons/faEllipsisStroke';
import faEye from './fortawesomeIcons/sharp-regular-svg-icons/faEye';
import faEyeSlash from './fortawesomeIcons/sharp-regular-svg-icons/faEyeSlash';
import faItalic from './fortawesomeIcons/sharp-regular-svg-icons/faItalic';
import faLayerGroup from './fortawesomeIcons/sharp-regular-svg-icons/faLayerGroup';
import faLineHeight from './fortawesomeIcons/sharp-regular-svg-icons/faLineHeight';
import faMessageCaptions from './fortawesomeIcons/sharp-regular-svg-icons/faMessageCaptions';
import faMessageText from './fortawesomeIcons/sharp-regular-svg-icons/faMessageText';
import faPalette from './fortawesomeIcons/sharp-regular-svg-icons/faPalette';
import faPercent from './fortawesomeIcons/sharp-regular-svg-icons/faPercent';
import faTextHeight from './fortawesomeIcons/sharp-regular-svg-icons/faTextHeight';
import faTextSize from './fortawesomeIcons/sharp-regular-svg-icons/faTextSize';
import faUnderline from './fortawesomeIcons/sharp-regular-svg-icons/faUnderline';

export default {

  fields: {
    //Block types
    blockHeading: faHeading,
    blockParagraph: faFontCase,
    blockEmptyspace: faArrowsMaximize,

    //Selector
    selector: faCircleCheck,
    selectorCheck: faCheck,
    selectorRadio: faDotCircle,

    //Fields
    richText: faPaintbrushPencil,
    dropdown: faListDropdown,
    date: faCalendarClock,
    number: faHashtag,
    text: faInputPipe,
    textarea: faSquarePollHorizontal,
    multiSelect: faListCheck,
    multiSelectSingle: faListRadio,
    signature: faSignature,
    image: faImage,
    file: faFolderArrowUp,
    chart: faChartLine,
    barcode: faBarcode,
    collection: faTableTree,
    pricingTable: faMoneyCheckDollarPen,

    table: faTableCells,
    tableInputGroup: faTableRows,
    tableCell: faDiagramSubtask,
    tableColumn: faTableColumns,
    upload: faImage,

  },
  misc: {
    info: faCircleInfo,
    search: faMagnifyingGlass,
    add: faPlus,
    eyeSlash: faEyeSlash,
    eye: faEye,
    submit: faCheck,
    close: faTimes,
    preview: faExternalLinkAlt,
    drag: faGripVertical,
    resize: faArrows,
    chevronDown: faChevronDown,
    checked: faCheckSquare,
    unchecked: faSquare,
    radioChecked: faDotCircle,
    radioUnchecked: faCircle,
    caretDown: faCaretDown,
    caretRight: faCaretRight,
    refresh: faRefresh,
    exclamation: faTriangleExclamation,
    decorators: faEllipsisVertical,
  },
  settings: {
    page: faFileLines,
    pageRowHeight: faLineHeight,
    pageColumns: faColumns3,
    moveLeft: faChevronCircleLeft,
    moveRight: faChevronCircleRight,

    selectDisplayTypeOriginal: faList,
    selectDisplayTypeHorizontal: faEllipsisStroke,
    selectDisplayTypeText: faFont,
    selectDisplayTypeCheck: faCheckSquare,
    selectDisplayTypeCircle: faCircle,
    selectDisplayTypeSquare: faSquare,
    selectDisplayTypeRadio: faDotCircle,

    chartPrimaryDisplayOnly: faMoneyCheckPen,
    targetValue: faLink,
    primaryWidth: faArrowsLeftRight,
    primaryHeight: faArrowsUpDown,
    optionAdd: faPlus,
    multiImages: faImages,
    multi: faCheckDouble,
    upload: faCloudArrowUp,
    logic: faCodeBranch,
    identifier: faDatabase,
    formatDate: faCalendar,
    formatDateTime: faCalendarClock,
    formatTime: faClock,
    tooltipTitle: faMessageText,
    tooltipDescription: faMessageCaptions,
    required: faAsterisk,
    hide: faEyeSlash,
    disabled: faBan,
    display: faEye,
    styles: faPalette,
    settings: faCog,
    overflowEllipsis: faEllipsis,
    overflowWrap: faArrowTurnDownLeft,
    lineHeight: faLineHeight,
    lineHeightPercent: faPercent,
    fontSize: faTextSize,
    fontWeight: faBold,
    fontStyle: faItalic,
    textDecoration: faUnderline,
    textTransform: faTextHeight,
    clear: faCircleXmark,
    textAlignLeft: faAlignLeft,
    textAlignCenter: faAlignCenter,
    textAlignRight: faAlignRight,
    zIndex: faLayerGroup,
    edit: faEdit,
    duplicate: faCopy,
    delete: faCircleMinus,
    deleteSolid: faCircleMinusSolid,
    mobileScreen: faMobileScreenButton,
    webScreen: faTv,
  },
  tableSettings: {
    columnEdit: faEdit,
    columnMoveLeft: faChevronCircleLeft,
    columnMoveRight: faChevronCircleRight,
  },
  decorator: {
    camera: faCamera,
    import: faFileImport,
    paperclip: faPaperclip,
    image: faImage,
    file: faFile,
    comment: faComment,
    comments: faComments,
    upload: faUpload,
    download: faDownload,
    rotate: faRotate,
    cloud: faCloud,
    filter: faFilter,
    share: faShare,
    paperPlane: faPaperPlane,
    folder: faFolder,
    folderOpen: faFolderOpen,
    magnet: faMagnet,
    eye: faEye,
    circleInfo: faCircleInfo,
    plus: faPlus,
    flag: faFlag,
    pencil: faPencil,
    penToSquare: faPenToSquareSolid,
  },
};
